import { SENSITIVE_DATA_LINKED_TYPE } from "constants/sensitiveData";
import {
  SensitiveDataLinkedAddress,
  SensitiveDataLinkedObject,
} from "types/Models/sensitiveData";

export type SensitiveDataLinkedRow = {
  label: string;
  value: string;
  isFullWidth?: boolean;
};

const formatLinkedAddress = (
  address?: SensitiveDataLinkedAddress | null
): string =>
  [
    address?.street_address,
    address?.street_address_line_2,
    address?.city,
    address?.state,
    address?.zipcode,
    address?.country,
  ]
    .filter(Boolean)
    .join(", ");

export const getSensitiveDataLinkedRows = (
  linkedObject?: SensitiveDataLinkedObject
): SensitiveDataLinkedRow[] => {
  if (!linkedObject) return [];

  if (linkedObject.type === SENSITIVE_DATA_LINKED_TYPE.BANK) {
    const address = formatLinkedAddress(linkedObject.address);

    if (!address) return [];

    return [
      {
        label: "Account holder's name",
        value: linkedObject.account_holder_name || "",
      },
      { label: "Address", value: address, isFullWidth: true },
    ].filter(({ value }) => Boolean(value));
  }

  const { email, phone_number, country_of_residence, residential_address } =
    linkedObject;

  return [
    { label: "Email address", value: email || "" },
    { label: "Phone number", value: phone_number || "" },
    { label: "Country of residence", value: country_of_residence || "" },
    {
      label: "Residential address",
      value: formatLinkedAddress(residential_address),
      isFullWidth: true,
    },
  ].filter(({ value }) => Boolean(value));
};
